<template>
    <div class="contact-form-wrapper">
        <h4 class="title">{{ $t('help.contact_form') }}</h4>
        <p class="notice-text">
            {{
                $t('help.send_us_a_message_with_your_question_and_or_comment_we_try_to_respond_within_one_business_day')
            }}
        </p>

        <b-form
            class="contact-form"
            @reset="onReset">
            <b-form-group
                class="name-group"
                id="input-group-name"
                :label="$t('help.your_name')"
                label-for="input-group-name-field">
                <b-form-input
                    id="input-group-name-field"
                    v-model="form.name"
                    required
                    :placeholder="$t('help.fill_in_your_name')"></b-form-input>
            </b-form-group>

            <b-form-group
                class="email-group"
                id="input-group-email"
                label="E-mail:"
                label-for="input-group-email-field">
                <b-form-input
                    id="input-group-email-field"
                    v-model="form.email"
                    type="email"
                    required
                    :placeholder="$t('help.fill_in_your_email_address')"></b-form-input>
            </b-form-group>

            <b-form-group
                class="group-subject"
                id="input-group-remarks"
                :label="$t('help.question_or_remark')"
                label-for="input-group-remarks-field">
                <b-form-textarea
                    class="apprentice-textarea"
                    id="input-group-remarks-field"
                    v-model="form.description"
                    :placeholder="$t('help.fill_your_message_in')"
                    rows="5"
                    max-rows="8">
                </b-form-textarea>
            </b-form-group>

            <div class="submit">
                <b-button
                    class="btn-submit-contact-form"
                    type="button"
                    variant="primary"
                    @click="onSubmit">
                    {{ $t('help.send') }}
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
export default {
    name: 'design-2021-help-contact-form-component',
    props: {
        userIn: Object,
        userType: {
            type: String,
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                description: '',
            },
        };
    },
    methods: {
        onSubmit() {
            const uri = this.$authUser.isExternal() ? 'external/organization/contact/send' : 'help/send';

            this.alert.saving();

            this.axios.post(uri, this.form).then(
                (response) => {
                    this.onReset();
                    this.alert.success(this.$t('help.message_is_send'));
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        onReset(evt) {
            // Reset our form values
            this.form.description = '';
        },
    },
    created() {
        this.form.name = this.userIn.full_name;
        this.form.email = this.userIn.email;
    },
};
</script>

<style scoped lang="scss">
.contact-form-wrapper {
    background-color: $white;
    padding: $grid-gutter-width;
    margin-bottom: 0;

    input.form-control,
    textarea.form-control,
    .form-group {
        margin-bottom: 0;
    }
}

.notice-text {
    margin-bottom: 52px;

    p {
        margin-bottom: 0;
    }
}

.contact-form {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: space-between;
    gap: map-get($grid-gutter-spacing, 'twenty-one') $grid-gutter-width;
}

.name-group,
.email-group,
.group-subject,
.submit {
    flex: 1 0 100%;
}
.group-subject {
    textarea {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .name-group,
    .email-group {
        flex: 1 1 calc(50% - 15px);
    }
}
</style>
